import { render, staticRenderFns } from "./MailSMS.vue?vue&type=template&id=0aaf7a0f"
import script from "./MailSMS.vue?vue&type=script&lang=js"
export * from "./MailSMS.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports